<template>
    <div class="container-text-page">
    <div
      v-for="attribute in errors"
      :key="attribute[0]"
      class="alert alert-danger"
    >
      {{ attribute[0] }}
    </div>
    <h4 class="m-3">Текстовая страница</h4>
    <el-form ref="form" label-position="left" label-width="220px" class="text-page__form">
      <el-form-item label="Название">
        <div class="text-form__title">
          <el-input v-model="form.title"></el-input>
        </div>
      </el-form-item>
        <el-form-item label="Название ссылки">
        <div class="text-form__title">
          <el-input v-model="form.link_title"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="Контент">
        <ckeditor v-model="form.content"></ckeditor>
      </el-form-item>
      <el-form-item label="Шапка страницы">
        <el-checkbox v-model="form.header.show"></el-checkbox>
        <el-form-item label="Сортировка">
          <div class="text-form__sort">
            <el-input type="number" v-model="form.header.sort"></el-input>
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item label="Подвал страницы">
        <el-checkbox v-model="form.footer.show"></el-checkbox>
        <el-form-item v-if="form.footer.show">
          <p>Выбрать секцию</p>
         <el-select
            :value="form.footer.section_id"
            :width="300"
            @change="changeSection"
          >
            <el-option v-for="(item,index) in footerSections" :key="index" :value="item.id" :label="item.title"></el-option>
          </el-select>
          <el-button class="text-form__btn" @click="() => openSectionDialog()">Добавить секцию</el-button>
        </el-form-item>
        <el-form-item class="text-form__sort--footer" label="Сортировка">
          <div class="text-form__sort">
            <el-input type="number" v-model="form.footer.sort"></el-input>
          </div>
        </el-form-item>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="(e) => addTextPage(e)">Изменить</el-button>
        <el-button @click="cancelTextPage">Отмена</el-button>
      </el-form-item>
    </el-form>
    <TextPageFooterSectionPopup @create-section="createSection"/>
  </div>
</template>

<script>
import axios from 'axios';
import { SETPRELOADER_STATE } from '../../store/mutation-types.js';
import useFormData from '../../composable/useFormData.js'
import TextPageFooterSectionPopup from './TextPageFooterSectionPopup.vue';

export default {
  components: {
    TextPageFooterSectionPopup
  },
  data() {
    return {
      form: {
        title: '',
        content: '',
        link_title: '',
        sort: 0,
        header: {
          show: false,
          sort: 0,
        },
        footer: {
          show: false,
          sort: 0,
          section_id: ''
        },
        activity: true,
      },
      query: {
        sort: {
          by: 'title',
          order: 'asc'
        }  
      },
      section_id: '',
      errors: [],
      footerSections: []
    }
  },
  mounted() {
    this.getPage()
  }, 
  methods: {
    getPage() {
      const footerSections = this.$store.getters.footerSections

      this.setFooterSections(footerSections)
      this.setTextPage()
    },
    setFooterSections(footerSections) {
      if (!footerSections?.length) {
        this.$store.commit(SETPRELOADER_STATE, true)
        
        axios.get(`/page/footer-section`).then((response) => {
          this.footerSections = response.data
        }).finally(() => {
           this.$store.commit(SETPRELOADER_STATE, false)
        })
      } else {
         this.footerSections = footerSections
      }
    },
    setTextPage() {
      const page = this.$store.getters.textPage

      if (!page.id) {
        const id = this.$route.params.id

        axios.get(`/page/${id}`).then((response) => {
          this.initValue(response.data)
        })
      } else {
        this.form = page
      }
    },
    addTextPage(e) {      
      const t = e.target;
      const { execute } = useFormData()

      this.changeForm()
      const data = execute().setFields(Object.keys(this.form)).getFormData(this.form)

      this.$store.commit(SETPRELOADER_STATE, true)
      t.style.pointerEvents = 'none';
      const id = this.$route.params.id;

      axios.post(`/page/${id}`, data).then(() => {
        this.cancelTextPage()
      })
      .catch((errors) => {
        this.errors = errors.response.data.errors
      })
      .finally(() => {
        this.$store.commit(SETPRELOADER_STATE, false)
        t.style.pointerEvents = 'all';
      })
    },
    cancelTextPage() {
      this.$router.go(-1)
    },
    openSectionDialog() {
      this.$store.commit('openFooterSectionCreateDialogPopup', true)
    },
    createSection(section) {
      this.footerSections.push(section)
    },
    changeSection(id) {
      this.form.footer.section_id = id
    },
    changeForm() {
      this.form.footer.section_id = this.form.footer?.section_id ?? '';
    },
    initValue(value) {
      if (value) {
        this.form.title = value.title || '';
        this.form.content = value.content || '';
        this.form.link_title = value.link_title || '';
        this.form.sort = value.title || '';
        this.form.header.show = value.header?.show || false;
        this.form.header.sort = value.header?.sort || 0;
        this.form.footer.show = value.footer?.show || false;
        this.form.footer.sort = value.footer?.sort || 0;
        this.form.footer.section_id = value.footer?.section?.id || '';
        this.form.activity = value.activity || false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    margin-bottom: 5px;
    color: #606266;
  }

  .text-form {
    &__btn {
      margin-left: 15px;
    }

    &__sort {
      max-width: 380px;

      &--footer {
        margin-top: 25px;
      }
    }
  }
</style>